"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.small = exports.mini = exports.large = void 0;

var _core = require("@emotion/core");

var _vars = _interopRequireDefault(require("./vars"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mini = /*#__PURE__*/(0, _core.css)("padding:", _vars.default.size.mini.padding, ";font-size:", _vars.default.size.mini.fontSize, ";line-height:", _vars.default.size.mini.lineHeight, ";");
exports.mini = mini;
var small = /*#__PURE__*/(0, _core.css)("padding:", _vars.default.size.small.padding, ";font-size:", _vars.default.size.small.fontSize, ";line-height:", _vars.default.size.small.lineHeight, ";");
exports.small = small;
var large = /*#__PURE__*/(0, _core.css)("padding:", _vars.default.size.large.padding, ";font-size:", _vars.default.size.large.fontSize, ";line-height:", _vars.default.size.large.lineHeight, ";");
exports.large = large;